import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import {
    computed,
    ref,
    Ref,
} from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { UpsertBrandAuth } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { FieldEnable } from '@/types/types'
import SelectPaymentChannel from '@/components/SelectPaymentChannel.vue'



import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'OperatorTerminalConfigPCUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {
        type: Boolean,
        required: true,
    },
    operatorId: {
        type: String,
        required: true,
    },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
    (e: 'update:modelValue', value: boolean): void
    (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { paymentModes } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())

const isSubmitting = ref(false)
const showDialog = computed({
    get: () => props.modelValue,
    set: (val: boolean) => {
        emit('update:modelValue', val)
    },
})

const submit = async () => {
    try {
        await formCom.value.validate()
        isSubmitting.value = true

        formData.value.operatorId = props.operatorId
        if (formData.value.isDefault) {
            formData.value.isDefault = FieldEnable.CES_ENABLE
        } else {
            formData.value.isDefault = FieldEnable.CES_DISABLE
        }
        if (formData.value.defaultPs) {
            formData.value.defaultPs = FieldEnable.CES_ENABLE
        } else {
            formData.value.defaultPs = FieldEnable.CES_DISABLE
        }

        await UpsertBrandAuth(formData.value)

        ElMessage.success(t(`Base.opSuccess`))
        emit('submitted')
        showDialog.value = false
    } catch (error) {
        //
    } finally {
        isSubmitting.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    title: _unref(t)('Operation.bindpc'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: _ctx.operatorFormRule
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.paymentMode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.pm,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.pm) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentModes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.selectPayment'),
                    prop: "paymentChannelId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectPaymentChannel, {
                        modelValue: formData.value.paymentChannelId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.paymentChannelId) = $event)),
                        operatorID: props.operatorId
                      }, null, 8, ["modelValue", "operatorID"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.defpc'),
                    prop: "isDefault"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: formData.value.isDefault,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.isDefault) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.pspc'),
                    prop: "defaultPs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: formData.value.defaultPs,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.defaultPs) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})